// Dane rejestrowe i kontaktowe usługodawcy — jedno źródło prawdy dla stopki,
// strony "Dane kontaktowe" i checkboxa akceptacji regulaminu. Muszą pozostać
// zgodne z § 1 pkt 13 oraz § 14 Regulaminu (client/src/legal/regulamin.pdf).
// Uwaga: te same dane są zduplikowane w motywie logowania
// (keycloakify/src/components/CompanyContactFooter.tsx) — to osobna aplikacja,
// która nie może importować z klienta. Zmieniając tutaj, zmień też tam.
export const COMPANY_INFO = {
  legalName: 'Claro Connect spółka z ograniczoną odpowiedzialnością',
  shortName: 'Claro Connect sp. z o.o.',
  street: 'ul. Św. Wincentego 126A lok. 28',
  postalCode: '03-291',
  city: 'Warszawa',
  country: 'Polska',
  nip: '5243036785',
  regon: '541445393',
  krs: '0001167386',
  krsCourt:
    'Sąd Rejonowy dla m.st. Warszawy w Warszawie, XIV Wydział Gospodarczy Krajowego Rejestru Sądowego',
  shareCapital: '5 000,00 zł',
  email: 'biuro@claroconnect.pl',
  supportEmail: 'serwis@easytacho.pl',
  phone: '+48 22 379 70 26',
  phoneHref: '+48223797026',
  supportHours: 'dni robocze, 8:00–16:00',
} as const

export const COMPANY_ADDRESS_LINE = `${COMPANY_INFO.street}, ${COMPANY_INFO.postalCode} ${COMPANY_INFO.city}`
